// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xwJW","buttons":"styles_buttons__2pLBH"};